import React, { useEffect, useState } from "react";
import "../styles/footer.css";
import { Link } from "react-router-dom";
import { getWeather } from "../Services/AllAPIs";

const Footer = () => {
    const [weather, setWeather] = useState({
        description: "",
        temperature: "",
        humidity: "",
        windSpeed: "",
        icon: "",
    });

    const [dateTime, setDateTime] = useState("");
    const [visitorCount, setVisitorCount] = useState(0);

    const getWeatherDetail = () => {
        getWeather()
            .then((res) => {
                const weatherData = res.data.weather[0];
                const mainData = res.data.main;
                const windData = res.data.wind;
                setWeather({
                    description: weatherData.description,
                    temperature: mainData.temp,
                    humidity: mainData.humidity,
                    windSpeed: windData.speed,
                    icon: weatherData.icon,
                });
            })
            .catch((error) => console.log(error));
    };

    // Function to update the date and time
    const updateDateTime = () => {
        const now = new Date();
        const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            timeZoneName: "short",
        };
        const dateTimeString = now.toLocaleDateString("en-US", options);
        setDateTime(dateTimeString);
    };

    useEffect(() => {
        // Initialize visitor count, defaulting to 1179360
        const initialCount = JSON.parse(localStorage.getItem('visitorCount')) || 370087;
        setVisitorCount(initialCount);

        // Update weather details and time on initial render
        getWeatherDetail();
        updateDateTime();

        // Function to increment the visitor count every 1 minute
        const incrementVisitorCount = () => {
            const updatedCount = visitorCount + 1;
            setVisitorCount(updatedCount);
            localStorage.setItem('visitorCount', JSON.stringify(updatedCount)); // Store the updated count
        };

        // Set interval to increment visitor count every 1 minute (60000 milliseconds)
        const intervalId = setInterval(incrementVisitorCount, 60000);

        // Set interval to update time every second
        const timeIntervalId = setInterval(updateDateTime, 1000);

        // Cleanup the intervals on component unmount
        return () => {
            clearInterval(intervalId);
            clearInterval(timeIntervalId);
        };
    }, [visitorCount]);

    // Function to split the visitor count into individual digits for buttons
    const getVisitorButtons = () => {
        return String(visitorCount)
            .split('')
            .map((count, index) => (
                <button key={index} className="visitor-button">
                    {count}
                </button>
            ));
    };

    return (
        <footer id="footer" className="footer">
            <div className="container-fluid p-40">
                <div className="row">
                    <div className="col-sm-4 col-md-4 col-lg-2">
                        <div className="widget dark">
                            <img
                                className="mb-1"
                                style={{ height: 200 }}
                                alt=""
                                src="/assets/images/footer/CCSU-footer-logo.png"
                            />
                            <p id="nacc" className="text-center m-0 p-0">
                                NAAC A++
                            </p>
                            <p className="text-center" id="nacdd">
                                <strong className="text-center">
                                    Chaudhary Charan Singh University, Meerut
                                </strong>
                            </p>
                            <ul className="mt-1 p-0">
                                <li className="m-0 pr-10" style={{ display: "block" }}>
                                    <a href="tel:01212763539">
                                        <i className="fa fa-phone" /> +91 121 2763539
                                    </a>
                                </li>
                                <li className="m-0 pr-10" style={{ display: "block" }}>
                                    <a href="tel:01212764777">
                                        <i className="fa fa-fax" /> +91 121 2764777
                                    </a>
                                </li>
                            </ul>
                            <ul className="styled-icons icon-sm icon-bordered icon-circled clearfix mt-10">
                                <li>
                                    <Link to={"https://www.facebook.com/CCSUFB"} target="_blank">
                                        <i className="fa fa-facebook" style={{ color: "white" }} />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"https://twitter.com/ccsumeerut"} target="_blank">
                                        <i className="fa fa-x-twitter" style={{ color: "white" }} />
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"https://youtube.com/channel/UCBRUtlVs5IJiAM61KZqDXrg"}
                                        target="_blank"
                                    >
                                        <i className="fa fa-youtube" style={{ color: "white" }} />
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"https://instagram.com/ccsuinsta"} target="_blank">
                                        <i className="fa fa-instagram" style={{ color: "white" }} />
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://www.linkedin.com/company/ch-charan-singh-university-meerut/"
                                        }
                                        target="_blank"
                                    >
                                        <i className="fa fa-linkedin" style={{ color: "white" }} />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-2">
                        <div className="widget dark">
                            <h4 className="widget-title line-bottom-theme-colored-2">
                                Academics
                            </h4>
                            <ul className="angle-double-right list-border pt-15">
                                <li>
                                    <Link to={"/academic-calendar"}>Academic Calendar</Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Calendar-BoS-AC_RDC.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Calender for BoS/ AC and RDC
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/departments"}>Departments</Link>
                                </li>
                                <li>
                                    <Link to={"/holidays-list"}>List of Holidays</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="widget dark mt-3">
                            <h4 className="widget-title line-bottom-theme-colored-2">
                                Important Links
                            </h4>
                            <ul className="angle-double-right list-border pt-15">
                                <li>
                                    <Link
                                        to={"https://uphed.gov.in/pdf/univeristy_Acta.pdf"}
                                        target="_blank"
                                    >
                                        UP State Universities Act
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/rti"}>Information Regarding RTI Act</Link>
                                </li>
                                <li>
                                    <Link to={"https://scic.ccsuniversity.ac.in"} target="_blank">
                                        Startup Cell &amp; Incubation Center
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"https://nodal.ccsuniversity.ac.in"}
                                        target="_blank"
                                    >
                                        Online Inventory for Campus
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"https://ccsums.ccsuniversity.ac.in/"}
                                        target="_blank"
                                    >
                                        CCTV Control Room Daily Report
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/verification"}>Document Verification</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-2">
                        <div className="widget dark">
                            <h4 className="widget-title line-bottom-theme-colored-2">
                                Policies
                            </h4>
                            <ul className="angle-double-right list-border pt-15">
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/international%20corporation%20policy.pdf"
                                        }
                                        target="_blank"
                                    >
                                        International Cooperation
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/ipr-policy.pdf"
                                        }
                                        target="_blank"
                                    >
                                        IPR Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/research_innov.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Research Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/IT-policy.pdf"
                                        }
                                        target="_blank"
                                    >
                                        IT Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/icc-policy.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Industry Consultancy
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/environment-policy.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Environment Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/policy/Centre%20for%20Translational%20Research.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Centre for Translational Research
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/infrastructure%20maintain.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Infrastructure
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/gender-policy.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Gender Equity
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/divyanjan-policy.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Divyangjan Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/ethics_values.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Ethics & Values Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://cdn.ccsuniversity.ac.in/public/jpeg/2025/05/fee_refund_policy_2024_2025.jpeg"
                                        }
                                        target="_blank"
                                    >
                                        Fee Refund Policy
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-2">
                        <div className="widget dark">
                            <h4 className="widget-title line-bottom-theme-colored-2">
                                Cells
                            </h4>
                            <ul className="angle-double-right list-border pt-15">
                                <li>
                                    <Link to={"https://cic.ccsuniversity.ac.in"} target="_blank">
                                        International Cooperation
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/industry-consultancy-cell"}>
                                        Industry Consultancy Cell
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"https://abacus.ccsuniversity.ac.in"}
                                        target="_blank"
                                    >
                                        ABACUS-UP
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"https://placement-cell.ccsuniversity.ac.in"}
                                        target="_blank"
                                    >
                                        Placement Cell
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"https://aishe.ccsuniversity.ac.in"}
                                        target="_blank"
                                    >
                                        AISHE
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"https://ipr.ccsuniversity.ac.in"} target="_blank">
                                        Intellectual Property
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/sedg-cell"} target="_blank">
                                        SEDG Cell
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-2">
                        <div className="widget dark">
                            <h4 className="widget-title line-bottom-theme-colored-2">
                                Quick Links
                            </h4>
                            <ul className="angle-double-right list-border pt-15">
                                <li>
                                    <Link
                                        to={
                                            "https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Adoption-IDF.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Institutional Development Plan (IDP)
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=id_token&scope=openid%20profile&client_id=5e3ce6c0-2b1f-4285-8d4b-75ee78787346&redirect_uri=https%3A%2F%2Fteams.microsoft.com%2Fgo&state=eyJpZCI6IjUxOTExMGE1LTlkMmMtNGY5Ny05OTg0LTYzODViMTFjZGQ5NyIsInRzIjoxNjY0Mjc3NzAzLCJtZXRob2QiOiJyZWRpcmVjdEludGVyYWN0aW9uIn0%3D&nonce=ce8ced2e-2f0c-495f-adf4-7f371a72001b&client_info=1&x-client-SKU=MSAL.JS&x-client-Ver=1.3.4&client-request-id=8bfb27cc-a73d-43bf-8ee1-93edd8dc70ab&response_mode=fragment"
                                        }
                                        target="_blank"
                                    >
                                        Microsoft Teams
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/downloads"}>Download</Link>
                                </li>
                                <li>
                                    <Link to={"/contact"}>Contact Us</Link>
                                </li>
                                <li>
                                    <Link to={"/iqac"}>IQAC</Link>
                                </li>
                                <li>
                                    <Link to={"/gallery"}>Gallery</Link>
                                </li>
                                <li>
                                    <Link to={"/university-news-letter"}>
                                        University News Letter
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"https://education-policy.ccsuniversity.ac.in/"}
                                        target="_blank"
                                    >
                                        NEP-2020
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/rti"}>RTI Act</Link>
                                </li>
                                <li>
                                    <Link
                                        to={"https://ccsuniversity.samarth.edu.in"}
                                        target="_blank"
                                    >
                                        Samarth login for Students
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/User%20Manual%20for%20Registration%20at%20the%20Student%20Portal_.pdf"
                                        }
                                        target="_blank"
                                    >
                                        Samarth portal user manual for student login
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/sahityik-sanskritik-parishad"}>
                                        Sahityik Sanskritik Parishad
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"https://swayam.inflibnet.ac.in/"} target="_blank">
                                        SWAYAM Portal
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/sustainability"}>
                                        Sustainability@CCSU
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/convocation"}>
                                        <b
                                            className="h6 convocation-head-footer"
                                            style={{
                                                color: "#f4c751",
                                                fontSize: 20,
                                                fontWeight: 700,
                                            }}
                                        >
                                            36th CONVOCATION 2024
                                        </b>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-2">
                        <div className="widget dark d-none">
                            <h4 className="widget-title line-bottom-theme-colored-2">
                                Google Form Link <br />
                                For Sending Report
                            </h4>
                            <ul className="angle-double-right list-border pt-15">
                                <li>
                                    <Link
                                        to={"https://forms.gle/n8TwxTk245um5yep6"}
                                        target="_blank"
                                    >
                                        <i className="fa fa-link" />
                                        पीपल के पेड़ो का वृक्षारोपण{" "}
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"https://forms.gle/XamwVRf4WbXudKWp7"}
                                        target="_blank"
                                        className=""
                                    >
                                        <i className="fa fa-link" /> महिला अध्ययन केंद्र की
                                        गतिविधियां
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={
                                            "https://docs.google.com/forms/d/1iH5GiSplzhdJ7xYEtOKT_MdcUjs14wA-uAnZeUyi0uA/edit?usp=sharing"
                                        }
                                        target="_blank"
                                        className="blink- "
                                    >
                                        <i className="fa fa-link" />
                                        &nbsp;राष्ट्रीय शिक्षा नीति प्रकोष्ठ
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="widget dark mt-4">
                            <h4 className="widget-title line-bottom-theme-colored-2">
                                Meerut, Uttar Pradesh, India
                            </h4>
                            <p id="realTime" className="pt-2" style={{ marginLeft: "-15px" }}>
                                {dateTime}
                            </p>
                        </div>
                        <div className="weather-container weather-container-general">
                            <div className="weather-icon">
                                <img
                                    id="weather-icon"
                                    src={`http://openweathermap.org/img/wn/${weather.icon}@2x.png`}
                                    alt="Weather Icon"
                                    style={{ padding: "0" }}
                                />
                            </div>
                            <div className="weather-details">
                                <h2 id="weather-description">
                                    {weather.description || "Loading..."}
                                </h2>
                                <p id="weather-temp">
                                    <strong>Temperature:</strong>{" "}
                                    {weather.temperature
                                        ? `${weather.temperature}°C`
                                        : "Loading..."}
                                </p>
                                <p id="weather-humidity">
                                    <strong>Humidity:</strong>{" "}
                                    {weather.humidity ? `${weather.humidity}%` : "Loading..."}
                                </p>
                                <p id="weather-wind">
                                    <strong>Wind:</strong>{" "}
                                    {weather.windSpeed
                                        ? `${weather.windSpeed} km/h`
                                        : "Loading..."}
                                </p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-around align-items-center app-store">
                            <div>
                                <h6>CCSU MOBILE APP </h6>
                            </div>
                            <div>
                                <Link
                                    to={
                                        "https://play.google.com/store/apps/details?id=com.ccsu&pli=1"
                                    }
                                    target="_blank"
                                >
                                    <img
                                        src="../assets/images/android_store.png"
                                        alt="android-store"
                                    />
                                </Link>
                                <Link
                                    to={
                                        "https://apps.apple.com/in/app/ccsu-meerut-official/id6446219464"
                                    }
                                    target="_blank"
                                >
                                    <img src="../assets/images/ios_store.png" alt="ios-store" />
                                </Link>
                            </div>
                        </div>
                        {/* <div className="d-flex justify-content-between align-items-center page-visitor visitor-mobile mt-3">
                            <div>
                                <p className="p-0 m-0">Total Visitor</p>
                            </div>
                            <div id="visitor-buttons">
                                <button className="visitor-button">7</button>
                                <button className="visitor-button">8</button>
                                <button className="visitor-button">2</button>
                                <button className="visitor-button">9</button>
                                <button className="visitor-button">2</button>
                                <button className="visitor-button">1</button>
                            </div>
                        </div> */}

                        <div className="d-flex justify-content-between align-items-center page-visitor visitor-mobile mt-3">
                            <div>
                                <p className="p-0 m-0">Total Visitor</p>
                            </div>
                            <div id="visitor-buttons">
                                {getVisitorButtons()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div
                    className="container-fluid pt-15"
                    style={{ background: "none", backgroundColor: "#f4c751" }}
                >
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <p
                                className="font-12 m-0 text-center pb-3"
                                style={{ color: "#14297a" }}
                            >
                                © Copyright Protected. Chaudhary Charan Singh University,
                                Meerut.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
